/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Only provided for WebhookType==Nem12Report
 * @export
 * @interface Nem12ReportMetadata
 */
export interface Nem12ReportMetadata {
    /**
     * List of deviceIds, or null for all devices. Prefer using DeviceGroupTag instead, for new webhooks.
     * @type {Array<string>}
     * @memberof Nem12ReportMetadata
     */
    deviceQuery?: Array<string>;
    /**
     * Report period
     * @type {string}
     * @memberof Nem12ReportMetadata
     */
    period?: Nem12ReportMetadataPeriodEnum;
    /**
     * Time in minutes of desired NEM Interval period (eg 5, 15, 30)
     * @type {number}
     * @memberof Nem12ReportMetadata
     */
    intervalMinutes?: number;
    /**
     * Report units, default Wh
     * @type {string}
     * @memberof Nem12ReportMetadata
     */
    unitOfMeasure?: Nem12ReportMetadataUnitOfMeasureEnum;
}

/**
 * @export
 */
export const Nem12ReportMetadataPeriodEnum = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;
export type Nem12ReportMetadataPeriodEnum =
    (typeof Nem12ReportMetadataPeriodEnum)[keyof typeof Nem12ReportMetadataPeriodEnum];

/**
 * @export
 */
export const Nem12ReportMetadataUnitOfMeasureEnum = {
    Wh: "Wh",
    KWh: "kWh",
} as const;
export type Nem12ReportMetadataUnitOfMeasureEnum =
    (typeof Nem12ReportMetadataUnitOfMeasureEnum)[keyof typeof Nem12ReportMetadataUnitOfMeasureEnum];

/**
 * Check if a given object implements the Nem12ReportMetadata interface.
 */
export function instanceOfNem12ReportMetadata(
    value: object,
): value is Nem12ReportMetadata {
    return true;
}

export function Nem12ReportMetadataFromJSON(json: any): Nem12ReportMetadata {
    return Nem12ReportMetadataFromJSONTyped(json, false);
}

export function Nem12ReportMetadataFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): Nem12ReportMetadata {
    if (json == null) {
        return json;
    }
    return {
        deviceQuery:
            json["deviceQuery"] == null ? undefined : json["deviceQuery"],
        period: json["period"] == null ? undefined : json["period"],
        intervalMinutes:
            json["intervalMinutes"] == null
                ? undefined
                : json["intervalMinutes"],
        unitOfMeasure:
            json["unitOfMeasure"] == null ? undefined : json["unitOfMeasure"],
    };
}

export function Nem12ReportMetadataToJSON(
    value?: Nem12ReportMetadata | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceQuery: value["deviceQuery"],
        period: value["period"],
        intervalMinutes: value["intervalMinutes"],
        unitOfMeasure: value["unitOfMeasure"],
    };
}
